import React, { useContext, useEffect, useState } from "react";
import { Measurement } from "../goal_templates/classes/measurements/measurement";
import { PatientGoal } from "../goal_templates/classes/patient_goal_class";
import { TextBlock } from "../goal_templates/common/components/generalUtilities";
import { SelectionStatus } from "./common/components/selectionStatus";
import { ModalContainer } from "./modalContainer";
import { TMDataContext } from "../utils/custom_hooks/TMDataContext";
import { PatientGoalDashboardPropsShape } from "../goal_templates/interfaces/componentTypes";

export const PatientGoalDashboard: React.FC<PatientGoalDashboardPropsShape> = ({
  profileInterviews,
  setErrorFound,
  setSelectedTemplate,
}) => {
  const { setModalStatus, goalTemplateSet, DBObject, uuid, t, viewOnly } =
    useContext(TMDataContext);
  // const [selectedTemplate, setSelectedTemplate] = useState();

  const checkErrors = () => {
    if (!goalTemplateSet || !profileInterviews) return;

    var foundErrors = [];
    goalTemplateSet.forEach((template) => {
      template.checkForEditorErrors(profileInterviews);
      if (template.hasErrors) {
        foundErrors.push(template.id);
      }
    });
    setErrorFound(foundErrors);
  };

  useEffect(() => {
    checkErrors();
  }, [profileInterviews, goalTemplateSet]);

  const formatColumnHeadings = () => {
    return DBObject.indexTableHeaders.map((header) => {
      return (
        <th
          key={uuid()}
          className="patient-goal-table-heading-cell"
          style={{ maxWidth: `${header.id == 1 ? "200px" : "none"}` }}
        >
          <span>{t(`views.goals.table.headings.${header.name}`)}</span>
        </th>
      );
    });
  };

  const formatLeaderboardStatus = (element) => {
    if (element.leaderboardEnabled) {
      if (element.type.name.includes("GoalTemplate")) {
        return t("views.goals.contexts.Leaderboard.enabled");
      } else {
        if (element.leaderboardIncluded) {
          return t("views.goals.contexts.Leaderboard.included");
        } else {
          return t("views.goals.contexts.Leaderboard.excluded");
        }
      }
    } else {
      return t("views.goals.contexts.Leaderboard.disabled");
    }
  };

  const buildTable = () => {
    if (!goalTemplateSet) return;
    return goalTemplateSet.map((rowElement) => {
      let goalFromTemplate = PatientGoal.findByTemplateId(rowElement.id);
      if (
        !!goalFromTemplate &&
        (goalFromTemplate.isSelectedForSaving() ||
          goalFromTemplate.isExistingGoal())
      ) {
        rowElement = goalFromTemplate;
      }
      return (
        <tr
          className={`patient-goal-table-data-row ${
            viewOnly ? "" : "editable"
          } ${rowElement.hasErrors ? "mismatch-error" : ""}`}
          key={uuid()}
        >
          <td className="patient-goal-table-data-cell">
            <SelectionStatus
              element={rowElement}
              setModalStatus={setModalStatus}
              setSelection={setSelectedTemplate}
              viewOnly={viewOnly}
            />
          </td>
          <td className="patient-goal-table-data-cell">{rowElement.name}</td>
          <td className="patient-goal-table-data-cell">
            {formatLeaderboardStatus(rowElement)}
          </td>
          <td className="patient-goal-table-data-cell">
            {rowElement.type.label}
          </td>
          <td className="patient-goal-table-data-cell">
            {rowElement.type.name.includes("Observation")
              ? rowElement.achievementCondition.label
              : "--"}
          </td>
          <td className="patient-goal-table-data-cell">
            {rowElement.achievementTarget}
          </td>
          <td className="patient-goal-table-data-cell">
            {rowElement.measurementId
              ? Measurement.findById(rowElement.measurementId).labelWithUnits()
              : "--"}
          </td>
          <td className="patient-goal-table-data-cell">
            {rowElement.occurrenceFrequency.label}
          </td>
          <td className="patient-goal-table-data-cell">
            {rowElement.occurrenceAmount == 0
              ? "Continuous"
              : rowElement.occurrenceAmount}
          </td>
          <td className="patient-goal-table-data-cell">
            {rowElement.type.name.includes("PatientGoal")
              ? rowElement.startDate
              : "--"}
          </td>
        </tr>
      );
    });
  };

  const templateTable = () => {
    return (
      <table className="patient-goal-table-wrapper">
        <thead>
          <tr className="patient-goal-table-heading-row">
            {formatColumnHeadings()}
          </tr>
        </thead>
        <tbody>{buildTable()}</tbody>
      </table>
    );
  };

  return (
    <>
      <div>
        {goalTemplateSet ? (
          templateTable()
        ) : (
          <TextBlock block={t("views.goals.errors.load_failure")} />
        )}
      </div>
    </>
  );
};
